package horcrux.frontend.common.views.collections.collectiondialogs

import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.views.components.containers.DialogAction
import horcrux.frontend.common.views.components.containers.DialogView
import mui.material.DialogContentText
import react.FC
import react.Props

external interface DeleteCollectionMetadataDialogProps : Props {
    var globalAppState: GlobalAppState
    var title: String
    var text: String
    var showDialogState: BooleanState
    var onClickDelete: () -> Unit
}

val DeleteCollectionMetadataDialog = FC<DeleteCollectionMetadataDialogProps> { props ->
    DialogView {
        this.title = props.title
        this.showDialogState = props.showDialogState
        this.dialogActionsMaybe = listOf(
            DialogAction("Cancel"),
            DialogAction("Delete") { showDialogState, _ ->
                props.onClickDelete()
                showDialogState.setFalse()
            },
        )
        DialogContentText {
            +props.text
        }
    }
}
